import React from 'react'
import styled from '@emotion/styled'
import Text, {
  DefaultFontProps,
  DefaultFontStyles
} from 'library/atoms/Typography/Text'

interface H1Props extends DefaultFontProps {
  fontStyle?: DefaultFontStyles['fontStyle']
}

/**
 * H1 component for replacing the H1 element
 * Note - we have hard set the marginBottom 4 here - this will result in a header with no top margin
 * according to the logic coming from Text
 * This is desirable in most cases since we have a bottom margin on the header in the widget to create
 * that separation. If you want to add the marginTop in aswell you can either use a marginTop prop or
 * the marginVertical prop (see Text component)
 */
const H1 = ({ children, fontStyle = 'h1', ...other }: H1Props) => {
  return (
    <StyledText fontStyle={fontStyle} as="h1" {...other}>
      {children}
    </StyledText>
  )
}

export default H1

/**
 * We change fontStyle based on whether we are viewing from a mobile device or not
 */
const StyledText = styled(Text)<Required<Pick<H1Props, 'fontStyle'>>>(({
  theme,
  fontStyle
}) => {
  const mobileFontStyle =
    fontStyle === 'h1'
      ? theme.fontStyle['h1Mobile']
      : theme.fontStyle[fontStyle]

  return {
    ...mobileFontStyle,
    [theme.mediaQueries.md]: {
      ...theme.fontStyle[fontStyle]
    }
  }
})
